import Link from 'next/link';
import type { ComponentProps, ReactNode } from 'react';

interface SmartLinkProps extends Omit<ComponentProps<'a'>, 'href'> {
  href: string;
  children: ReactNode;
}

/** The form and tool routes that benefit from client-side navigation and prefetch. */
const LINK_ROUTES = [
  '/contact-us',
  '/contact-success',
  '/get-quote',
  '/quote-success',
  '/sign-up-success',
  '/question-of-the-week',
  '/best-moves',
] as const;

const isLinkRoute = (href: string) =>
  LINK_ROUTES.some((route) => href === route || href.startsWith(`${route}/`));

/**
 * In-app Link for the form and tool routes; plain anchor for everything
 * else — the cheaper default for the ~40 nav links (no prefetch fan-out).
 */
export function SmartLink({ href, children, ...rest }: SmartLinkProps) {
  if (isLinkRoute(href)) {
    return (
      <Link href={href} {...rest}>
        {children}
      </Link>
    );
  }
  return (
    <a href={href} {...rest}>
      {children}
    </a>
  );
}
